export default "/assets/webpack-assets/hero-region.c2f297bf17bfc0b05436ca1df008ac45.jpg";